import { createGlobalStyle } from 'styled-components';
import { CDN_IMAGES_URL } from 'consts';

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 62.5%;
  }

  :root {
    --inter-font: 'Inter', sans-serif;
    --default-bg-color: rgba(249, 249, 249, 0.3);
  }

  body {
    font-size: 1.6rem;
    font-family: var(--inter-font);
    background-color: var(--default-bg-color);
    line-height: 1.5;
  }

  #root {
    position: relative;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    line-height: 1.5;
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    opacity: 1;
    transition: opacity 300ms;
  }

  .fade-exit {
    opacity: 1;
  }

  .fade-exit-active {
    opacity: 0;
    transition: opacity 300ms;
  }

  .slide-up-enter {
    transform: translateY(100%);
  }

  .slide-up-enter-active {
    transform: translateY(0%);
    transition: transform 300ms;
  }

  .slide-up-exit {
    transform: translateY(0%);
  }

  .slide-up-exit-active {
    transform: translateY(100%);
    transition: transform 300ms;
  }

  .slide-in-enter {
    transform: translateX(100%);
    width: 100%;
  }

  .slide-in-enter-active {
    left: 0;
    height: 100vh;
    width: 100%;
    transform: translateX(0%);
    transition: transform 300ms;
  }

  .slide-in-exit {
    position: absolute;
    left: 0;
    height: 100vh;
    width: 100%;
    transform: translateX(0%);
  }

  .slide-in-exit-active {
    transform: translateX(-100%);
    transition: transform 300ms;
    width: 100%;
  }

  .slide-out-enter {
    transform: translateX(-100%);
    width: 100%;
  }

  .slide-out-enter-active {
    height: 100vh;
    left: 0;
    width: 100%;
    transform: translateX(0%);
    transition: transform 300ms;
  }

  .slide-out-exit {
    position: absolute;
    height: 100vh;
    left: 0;
    width: 100%;
    transform: translateX(0%);
  }

  .slide-out-exit-active {
    transform: translateX(100%);
    transition: transform 300ms;
    width: 100%;
  }

  /* CSS for apple pay */
  @supports (-webkit-appearance: -apple-pay-button) {
    .apple-pay-button {
      display: inline-block;
      -webkit-appearance: -apple-pay-button;
    }

    .apple-pay-button-black {
      -apple-pay-button-style: black;
    }

    .apple-pay-button-white {
      -apple-pay-button-style: white;
    }

    .apple-pay-button-white-with-line {
      -apple-pay-button-style: white-outline;
    }
  }

  @supports not (-webkit-appearance: -apple-pay-button) {
    .apple-pay-button {
      display: inline-block;
      background-size: 100% 60%;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      border-radius: 4px;
      padding: 0px;
      box-sizing: border-box;
      min-width: 200px;
      min-height: 32px;
      max-height: 64px;
    }

    .apple-pay-button-black {
      background-image: -webkit-named-image(apple-pay-logo-white);
      background-color: black;
    }

    .apple-pay-button-white {
      background-image: -webkit-named-image(apple-pay-logo-black);
      background-color: white;
    }

    .apple-pay-button-white-with-line {
      background-image: -webkit-named-image(apple-pay-logo-black);
      background-color: white;
      border: 0.5px solid black;
    }
  }

  .preview-apple-pay-button-black {
    background-image: url('${CDN_IMAGES_URL}/apple-pay-icon-white.svg');
    background-color: black;
    background-size: 100% 50%;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 100rem white inset !important;
    background-color: white !important;
    background-clip: content-box !important;
  }

  input:-webkit-autofill:disabled {
    -webkit-box-shadow: 0 0 0 100rem #F1F1F1 inset !important;
  }

  & a {
    color: #0000EE;
  }

  strong {
    font-weight: 700;
  }
`;

export default GlobalStyle;
